export default __webpack_public_path__ + "static/thumb-landscape-9fd8ca6e242db5c44726e9450a3be611.jpg";